// Recover from stale lazy chunks after a deploy. A tab (or a phone that restored an old page from cache) can still
// hold the previous build's index, whose hashed route chunks no longer exist; importing one fails and the route
// would show the generic error screen. Reload once to pick up the current build; never loop.
const KEY = 'cg_chunk_reload_at';
const RE = /dynamically imported module|Importing a module script failed|error loading dynamically imported|Failed to fetch dynamically|Loading chunk [\w-]+ failed|Loading CSS chunk|is not a valid JavaScript MIME type|Unexpected token '<'|expected expression, got '<'/i;

export function isChunkError(err) {
  const msg = String(err?.message || err?.reason?.message || err || '');
  return err?.name === 'ChunkLoadError' || RE.test(msg);
}

/** Reload the page at most once per minute. Returns true when a reload was started. */
export function reloadOnce() {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 60000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* storage blocked (private mode): still try once per page */
    if (window.__cgChunkReloaded) return false;
    window.__cgChunkReloaded = true;
  }
  window.location.reload();
  return true;
}

export function installChunkReload() {
  if (typeof window === 'undefined') return;
  // Vite fires this when a dynamic import's preload fails.
  window.addEventListener('vite:preloadError', (e) => { if (reloadOnce()) e.preventDefault?.(); });
  window.addEventListener('unhandledrejection', (e) => { if (isChunkError(e.reason)) reloadOnce(); });
}
